module.exports = __webpack_public_path__ + "static/suport-intro-6dcbb702835351e488847ccc399c1ac0.png";